"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DelegatingGridLayout {
    getDelegate() {
        return this.delegate;
    }
    getDelegator() {
        return this.delegator;
    }
    setDelegate(delegate) {
        if (delegate || this.delegate) {
            const nextDelegator = delegate ? this : undefined;
            (delegate || this.delegate).setDelegator(nextDelegator);
        }
        this.delegate = delegate;
    }
    setDelegator(delegator) {
        this.delegator = delegator;
    }
    data2Tr(logicalRow) {
        return this.delegate.data2Tr(logicalRow);
    }
    data2DataRow(data) {
        return this.delegate.data2DataRow(data);
    }
    tr2Data(domRow) {
        return this.delegate.tr2Data(domRow);
    }
    tr2DataList(domRow) {
        return this.delegate.tr2DataList(domRow);
    }
    numInitialDomRows() {
        return this.delegate.numInitialDomRows();
    }
    isEmpty() {
        return this.numInitialDomRows() === 0;
    }
    getRowStyle(row) {
        return this.delegate.getRowStyle(row);
    }
    getRowAttributes(row) {
        return this.delegate.getRowAttributes(row);
    }
    getCellStyle(row, column) {
        return this.delegate.getCellStyle(row, column);
    }
    getColSpan(row, column) {
        return this.delegate.getColSpan(row, column);
    }
    renderCell(tdElement, ctx, row, column) {
        this.delegate.renderCell(tdElement, ctx, row, column);
    }
    dataChanged(sortApplied) {
        this.delegate.dataChanged(sortApplied);
    }
    postRender() {
        this.delegate.postRender();
    }
}
exports.default = DelegatingGridLayout;
//# sourceMappingURL=DelegatingGridLayout.js.map